import React from 'react';
import { useStepsState } from '../../hooks/zustandHooks';
import FeatherIcon from 'feather-icons-react';
import { useTranslation } from 'react-i18next';

const Sidebar = () => {
  const { t } = useTranslation();
  const { activeStep, steps } = useStepsState();

  return (
    <aside className="p-8 xl:p-16 bg-gray-200 min-w-[272px] w-[272px] xl:min-w-[400px] xl:w-[400px] hidden xl:block rounded-tr-2xl rounded-br-2xl">
      {activeStep?.singleStep ? (
        <div className="flex flex-col h-full">
          <div className="mb-10">
            <h2 className="text-md xl:text-lg font-semi-bold text-primary-2 mb-2 uppercase">
              {t(activeStep.title || '')}
            </h2>
            <p className="text-sm xl:text-md font-normal text-primary-2 m-0!">{t(activeStep.description || '')}</p>
          </div>
          <div className="bg-white p-6 h-full grow rounded-lg flex flex-col justify-between">
            <p className="text-sm xl:text-md">{t(activeStep.infoBox?.text || '')}</p>
            <a
              className="text-gray-500 text-sm xl:text-md flex gap-2 hover:underline"
              target="_blank"
              rel="noreferrer"
              href={activeStep.infoBox?.link?.href}
            >
              {t(activeStep.infoBox?.link?.text || '')}{' '}
              {activeStep.infoBox?.link?.icon && <FeatherIcon icon={activeStep.infoBox?.link?.icon} />}
            </a>
          </div>
        </div>
      ) : (
        <div className="flex flex-col justify-between h-full">
          <div>
            {steps.map(step => {
              if (step.singleStep) return null;
              const currentStep = activeStep?.title === step.title;
              return (
                <div key={step.stepIndex} aria-disabled={activeStep?.stepIndex !== step.stepIndex} className="mb-10">
                  <h2
                    className={`text-md xl:text-lg font-semi-bold uppercase ${
                      currentStep || !activeStep ? 'text-primary-2' : 'text-gray-500'
                    } mb-2`}
                  >
                    {t(step.title || '')}
                  </h2>
                  <p
                    className={`text-sm xl:text-md font-normal ${
                      currentStep || !activeStep ? 'text-gray-800' : 'text-gray-500'
                    } m-0!`}
                  >
                    {t(step.description || '')}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </aside>
  );
};

export default Sidebar;
